import { getIsDarkTheme } from '../selectors/getIsDarkTheme';
import { getRawPalette } from '../selectors/getRawPalette';

export const setThemeColorOnDocument = (): void => {
    const isDarkTheme = getIsDarkTheme();
    const palette = getRawPalette();

    // Setting theme color of the browser based on dark mode or light mode.
    const themeColor = isDarkTheme ? '#212121' : palette.themePrimary;
    document.querySelector('meta[name="theme-color"]').setAttribute('content', themeColor);
};
